import VodDetail from "./VodDetail";

export default VodDetail;
